// eslint-disable-next-line
import React, { ReactNode } from 'react';
import linea_fija_icon from 'assets/images/linea_fija_icon.svg';
import linea_iptv_icon from 'assets/images/linea_iptv_icon.svg';
import { BusinessName } from './entity.model';

const EntityIconLabel = ({ business }: { business?: string }): ReactNode => {
  if (!business) return <></>;
  switch (business) {
    case BusinessName.FIJO:
      return (
        <img src={linea_fija_icon} data-testid="linea-fija" alt="linea fija" />
      );
    case BusinessName.TV:
      return (
        <img src={linea_iptv_icon} data-testid="linea-iptv" alt="linea iptv" />
      );
    case BusinessName.ALL:
      return (
        <>
          <img
            src={linea_fija_icon}
            data-testid="linea-fija"
            alt="linea fija"
          />
          <img
            src={linea_iptv_icon}
            data-testid="linea-iptv"
            alt="linea iptv"
          />
        </>
      );
  }
};

export default EntityIconLabel;
